// variables de los tipos de 
// estados que puede tener una compra
export const StatusCompra = {
    comprando : "Comprando",
    enRevision : "En revisión",
    enEsperaDePago: "En espera de pago",
    revisionDePago: "Revisando tu pago",
    enCamino: "En camino",
    finalizado: "Finalizado"
}